export default __webpack_public_path__ + "static/media/JhengHeiUI.c0c988f6.ttf";